module.exports = __webpack_public_path__ + "160373d37abcf997a7abb7838e97f1d3.svg";